import React from 'react'
import styled from 'react-emotion'
import { urls } from '../../resources'
import getText from '../../resources/strings'
import { colors, Container } from '../../styles'

const HeaderMenu = styled('div')`
  background-color: ${colors.tui_white};
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  font-weight: bold;
  padding: 20px 0;
  margin-bottom: 20px;
  a.active {
    color: ${colors.tui_red} !important;
  }
  @media (max-width: 992px) {
    margin: 15px 10px 20px 10px;
    padding: 10px 5px 0 5px;
  }
`

const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`

const Back = styled('a')`
  @media (max-width: 992px) {
    flex-grow: 1;
    margin-bottom: 10px;
    text-align: center;
  }
`

export default () => {
  return (
    <HeaderMenu>
      <Container>
        <Wrapper>
          <Back href={urls.signIn}>{getText('buttons', 'back')}</Back>
        </Wrapper>
      </Container>
    </HeaderMenu>
  )
}
